<div class="dashboard-heading">
  <div class="title-container">
    <h2 class="title">
      {{ 'common.title.dashboard' | translateSafe}}
    </h2>

    <h3 class="sub-title">
      {{'common.title.monitoring-system' | translateSafe}}
    </h3>
  </div>
</div>

<div class="info-card-container">
  <app-info-card [title]="'common.title.active-devices' | translateSafe"
                 [activeDevices]="activeDeviceCount"
                 icon="water_drop"
                 routerLink="/devices"
                 [text]="lastActiveDeviceDateTime" />
  <!-- common.title.devices_since_yesterday || Geräte seit gestern-->

  <app-info-card class="red"
                 [title]="'common.title.active-alarm' | translateSafe"
                 [count]="activeAlarms.toString()"
                 icon="notification_important"
                 routerLink="/alarms"
                 [activeAlarmText]="activeAlarmCountText" />
</div>

<div class="row-container first">
  <app-dashboard-box [title]="'common.title.device-overview' | translateSafe"
                     buttonIconName="fullscreen"
                     [buttonLabel]="'common.actions.fullscreen' | translateSafe"
                     [class.fullscreen]="isFullscreen"
                     (buttonClick)="isFullscreen = true"
                     (click)="isFullscreen = false">
    <app-map [class.fullscreen]="isFullscreen" />
  </app-dashboard-box>
</div>

<div class="row-container second">
  <app-dashboard-box class="red"
                     [title]="'common.title.current-alarm' | translateSafe"
                     buttonIconName="arrow_forward"
                     (buttonClick)="goToAlarms()"
                     [buttonLabel]="'common.actions.all' | translateSafe">
    <app-current-alarm />
  </app-dashboard-box>

  <app-dashboard-box [title]="'common.title.alarm-distribution' | translateSafe"
                     icon="data_usage"
                     class="yellow">
    <app-alarms-pie-chart />
  </app-dashboard-box>
</div>

<div class="row-container third">
  <app-dashboard-box [title]="'common.title.water-consumption' | translateSafe"
                     icon="water_drop"
                     class="content-row">
    <div box-actions
         class="action-row">

      @if (hasAccess(AccountRole.OPERATOR)) {
        <app-button-icon iconName="download"
                         (click)="goToReports()" />
      }

      <app-time-range-selector (rangeSelected)="requestMeasurement($event)" />
    </div>

    <app-chart-mixed [data]="waterMeasurementData"
                     [options]="waterMeasurementOptions"
                     [enableTimeRangeSelector]="true"
                     (timeRangeChange)="requestMeasurement($event)" />

    <app-water-usage-per-district [waterUsageData]="waterUsagePerDistrictData"
                                  (selectedDistrictChange)="onDistrictSelected($event)" />
  </app-dashboard-box>
</div>
